import { AdminTemplate, MerchantSoftPOSAuthorizationForm } from "../../components"

export const MerchantSoftPOSAuthorization = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'İşyeri SoftPOS Yetkilendirme',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <MerchantSoftPOSAuthorizationForm />
    </AdminTemplate>
  )
}
